export default __webpack_public_path__ + "static/images/download-banner/lines-lit.png";